var _rect, _rect2, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _path10, _path11, _ellipse5, _ellipse6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3356_11992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#F3B286"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3356_11992)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "url(#paint0_linear_3356_11992)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44531 18.3223L34.0477 16.4901C32.9731 16.1951 28.9902 15.9208 20.5197 16.4901C11.1492 17.12 8.55248 17.9008 6.44531 18.3223Z",
    fill: "#A71216"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.83089,
    cy: 4.88391,
    rx: 3.31672,
    ry: 2.1978,
    transform: "rotate(18.2654 7.83089 4.88391)",
    fill: "#AB090D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.6911,
    cy: 8.71184,
    rx: 1.96174,
    ry: 1.60743,
    transform: "rotate(18.2654 14.6911 8.71184)",
    fill: "#AB090D"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0217,
    cy: 7.03625,
    rx: 1.85704,
    ry: 1.52164,
    transform: "rotate(41.5129 25.0217 7.03625)",
    fill: "#AB090D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.037,
    cy: 2.21304,
    rx: 1.27587,
    ry: 1.04543,
    transform: "rotate(55.3596 21.037 2.21304)",
    fill: "#AB090D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1403 4.97787C14.6312 5.47972 13.4264 4.13456 13.1721 3.00799C13.098 2.68005 13.2264 2.34982 13.4409 2.09101C14.2665 1.09513 15.3395 0.27195 16.3197 -0.256706C16.717 -0.47103 17.1827 -0.209139 17.2319 0.239649C17.4369 2.11166 17.3805 4.56548 16.1403 4.97787Z",
    fill: "#F1BB42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.774 4.19966C14.2338 4.21693 14.737 4.15955 15.2751 4.00409C16.4346 3.66906 17.0383 2.6501 17.3174 1.48143C17.3593 3.05881 17.1173 4.6528 16.1396 4.97793C15.167 5.30136 14.3208 4.85763 13.774 4.19966Z",
    fill: "url(#paint1_linear_3356_11992)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6793 10.1763C19.0986 10.3514 18.2017 8.78407 18.1886 7.62922C18.1848 7.29305 18.3794 6.99696 18.6433 6.78874C19.6589 5.98754 20.8803 5.40695 21.9494 5.09495C22.3827 4.96846 22.7834 5.32195 22.7376 5.7711C22.5466 7.64459 21.9783 10.0324 20.6793 10.1763Z",
    fill: "#F1BB42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5283 8.9203C18.9743 9.03334 19.4785 9.08246 20.0371 9.04296C21.2413 8.95781 22.0447 8.08737 22.5621 7.00269C22.2732 8.55419 21.7032 10.0628 20.679 10.1762C19.6602 10.2891 18.9254 9.67815 18.5283 8.9203Z",
    fill: "url(#paint2_linear_3356_11992)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8113 17.5867L6.64453 18.2646C7.31821 21.3225 9.40368 23.788 13.4455 23.2804C16.6789 22.8742 17.9384 19.681 17.8113 17.5867Z",
    fill: "#AB090D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3356_11992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 17,
    width: 12,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8113 17.5867L6.64453 18.2646C7.29247 20.8985 9.35641 23.0094 13.4004 22.5377C16.6356 22.1602 17.921 19.3935 17.8113 17.5867Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3356_11992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8113 17.5867L6.64453 18.2646C7.29247 20.8985 9.35641 23.0094 13.4004 22.5377C16.6356 22.1602 17.921 19.3935 17.8113 17.5867Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3996 16.3714L24.2988 16.9937C24.8427 19.704 26.4958 21.6373 29.7903 21.1795C32.4258 20.8133 33.4997 18.2284 33.3996 16.3714Z",
    fill: "#AB090D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3356_11992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 16,
    width: 10,
    height: 5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3996 16.3714L24.2988 16.9937C24.8269 19.4109 26.4683 21.126 29.7641 20.6931C32.4007 20.3467 33.489 18.0296 33.3996 16.3714Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3356_11992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3996 16.3714L24.2988 16.9937C24.8269 19.4109 26.4683 21.126 29.7641 20.6931C32.4007 20.3467 33.489 18.0296 33.3996 16.3714Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2244 32.7279L10.7549 29.8254H13.8643L12.8761 32.6836C12.7737 32.9797 12.3659 33.0074 12.2244 32.7279Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2084 26.8953C22.8684 28.9803 12.4955 29.4699 8.35156 29.4541C8.35156 30.4138 11.9369 30.4582 17.7451 29.7391C23.5533 29.02 29.5274 28.0243 30.4125 27.6924C31.1205 27.4269 31.2381 27.0503 31.2084 26.8953Z",
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1927,
    cy: 24.2841,
    rx: 1.28645,
    ry: 0.785687,
    transform: "rotate(31.1469 20.1927 24.2841)",
    fill: "#570D11"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2504,
    cy: 23.9656,
    rx: 1.03935,
    ry: 0.634775,
    transform: "rotate(121.323 24.2504 23.9656)",
    fill: "#570D11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3356_11992",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F23F4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3356_11992",
    x1: 15.3452,
    y1: 1.90319,
    x2: 16.1788,
    y2: 5.80051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69C1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3356_11992",
    x1: 20.5452,
    y1: 7.00269,
    x2: 20.5453,
    y2: 10.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69C1C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankProfile);
export default __webpack_public_path__ + "static/media/blank-profile.15480ac26a97ff0375efd643148e30a5.svg";
export { ForwardRef as ReactComponent };